'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSupplementalInitialMessages = fetchSupplementalInitialMessages;

var _noAuthApiClient = require('../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchSupplementalInitialMessages(_ref) {
  var botId = _ref.botId,
      sessionId = _ref.sessionId;

  return _noAuthApiClient2.default.getWithResponse('bots-public/v1/welcome', {
    query: { botId: botId, sessionId: sessionId }
  });
}


//////////////////
// WEBPACK FOOTER
// ./js/clients/fetchSupplementalInitialMessages.js
// module id = 438
// module chunks = 2 3